import MainConnection from "./MainConnection";

export default {
  /* ### Prospect Customer ### */
  // GET : request a list of prospect customers in pagination format
  requestProspectCustomers: async function(page) {
    const requestUrl = "/prospects?page=" + page;
    try {
      const response = await MainConnection.request().get(requestUrl);
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  // GET : request a list of prospect customers in pagination format
  requestProspectCustomerDetailById: async function(prospectId) {
    const requestUrl = "/prospects/" + prospectId;
    try {
      const response = await MainConnection.request().get(requestUrl);
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  // GET : request location token for specified prospect customer
  requestProspectCustomerLocationTokenById: async function(prospectId) {
    const requestUrl = "/prospects/" + prospectId + "/register";
    try {
      const response = await MainConnection.request().get(requestUrl);
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  // PATCH : request update location of prospect customers by id
  requestUpdateProspectCustomerLocation: async function(updateParams) {
    const requestUrl = "/prospects/" + updateParams.cust_id + "/location";
    try {
      const response = await MainConnection.request().patch(requestUrl, {
        location_token: updateParams.location_token
      });
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  // PATCH : request update contact of prospect customers by id
  requestUpdateProspectContactNumber: async function(updateParams) {
    const requestUrl = "/prospects/" + updateParams.cust_id + "/contactNumber";
    try {
      const response = await MainConnection.request().patch(requestUrl, {
        contact_token: updateParams.contact_token
      });
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  // PATCH : request update status of prospect customers by id
  requestUpdateProspectCustomerStatus: async function(updateParams) {
    const requestUrl = "/prospects/" + updateParams.id + "/status";
    try {
      const response = await MainConnection.request().patch(requestUrl, {
        status: updateParams.status
      });
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  // DELETE : request remove operation on prospect customer by id
  requestRemoveProspectCustomers: async function(prospectCustomerID) {
    const requestUrl = "/prospects/" + prospectCustomerID;
    try {
      const response = await MainConnection.request().delete(requestUrl);
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  /* ### Customer ### */
  // POST : request an add operation for new customer
  requestCreateCustomer: async function(registerParams) {
    try {
      const response = await MainConnection.request().post(
        "/customers",
        registerParams
      );
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  // GET : request a list of matched customers' msisdn, imei, or esn
  requestSearchCustomer: async function(searchText) {
    try {
      const requestUrl = "/customers?search=" + searchText;
      const response = await MainConnection.request().get(requestUrl);
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  // GET : request a list of all customers in date backward
  requestBackwardCustomer: async function(backwardDate) {
    try {
      const requestUrl = "/customers?day=" + backwardDate;
      const response = await MainConnection.request().get(requestUrl);
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  /* ### Customer Detail ### */
  // GET : request a customer profile by customer_id or msisdn
  requestCustomerDetail: async function(customer_indicator) {
    try {
      const requestUrl = "/customers/" + customer_indicator;
      const response = await MainConnection.request().get(requestUrl);
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  // POST : request a customer rollback registration by msisdn & contact No.
  requestCustomerRollback: async function(msisdn, contact_number) {
    const rollbackParams = {
      msisdn,
      contact_number
    };
    const requestUrl = "/customers/rollback";
    try {
      const response = await MainConnection.request().post(
        requestUrl,
        rollbackParams
      );

      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  // PATCH : request update IMEI by customer_id
  requestUpdateImei: async function(updateImeiParams) {
    const updatedImei = {
      imei: updateImeiParams.imei
    };
    const requestUrl = "/customers/" + updateImeiParams.cust_id + "/imei";
    try {
      const response = await MainConnection.request().patch(
        requestUrl,
        updatedImei
      );

      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  // PATCH : request update Lock Distance by customer_id
  requestUpdateLockDistance: async function(updateDistanceParams) {
    const updatedLockDistance = {
      lock_distance: updateDistanceParams.lock_distance
    };
    const requestUrl =
      "/customers/" + updateDistanceParams.cust_id + "/distance";
    try {
      const response = await MainConnection.request().patch(
        requestUrl,
        updatedLockDistance
      );
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  // PATCH : request update Registered Location by customer_id
  requestUpdateResgisteredLocation: async function(updateLocationParams) {
    const updatedLocation = {
      location_token: updateLocationParams.location_token
    };
    const requestUrl =
      "/customers/" + updateLocationParams.cust_id + "/location";
    try {
      const response = await MainConnection.request().patch(
        requestUrl,
        updatedLocation
      );
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  // PATCH : request update Contact Number Location by customer_id
  requestUpdateResgisteredContactNumber: async function(updateContactParams) {
    const updatedContact = {
      contact_token: updateContactParams.contact_token
    };
    const requestUrl =
      "/customers/" + updateContactParams.cust_id + "/contactNumber";
    try {
      const response = await MainConnection.request().patch(
        requestUrl,
        updatedContact
      );
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  // POST : request reset PCRF status by customer_id
  requestResetPcrfStatus: async function(customerId) {
    const requestUrl = "/customers/" + customerId + "/pcrf/reset";
    try {
      const response = await MainConnection.request().post(requestUrl);
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  // GET : request a list of PCRF's history by customer id
  requestPcrfHistory: async function(customer_id) {
    const requestUrl = "/customers/" + customer_id + "/pcrf";
    try {
      const response = await MainConnection.request().get(requestUrl);
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  // GET : request a list of retry queue by customer id
  requestRetryQueue: async function(customer_id) {
    const requestUrl = "/customers/" + customer_id + "/queue";
    try {
      const response = await MainConnection.request().get(requestUrl);
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  // GET : request a list of Dtac@Home's history by customer id
  requestDahHistory: async function(customer_id) {
    const requestUrl = "/customers/" + customer_id + "/history";
    try {
      const response = await MainConnection.request().get(requestUrl);
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  // GET : request a list of customer location as well as their registered sites by customer id
  requestCustomerSites: async function(customer_id) {
    const requestUrl = "/customers/" + customer_id + "/location";
    try {
      const response = await MainConnection.request().get(requestUrl);
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  }
};
